import React, { useState } from 'react';
import { ClipboardList } from 'lucide-react';
import IncidenciasPage from './IncidenciasPage';
import SancionesPage from './SancionesPage';

const TABS = [
    { id: 'incidencias', label: 'Incidencias', component: IncidenciasPage },
    { id: 'sanciones', label: 'Sanciones', component: SancionesPage }
];

const OperacionesPage = () => {
    const [activeTab, setActiveTab] = useState('incidencias');

    const ActiveComponent = TABS.find(tab => tab.id === activeTab)?.component;

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center gap-3">
                    <div className="p-2 rounded-lg bg-orange-500/20">
                        <ClipboardList className="text-orange-400" size={24} />
                    </div>
                    <div>
                        <h1 className="text-2xl font-bold text-white">Operaciones</h1>
                        <p className="text-slate-400">Gestión de incidencias y sanciones</p>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="border-b border-slate-700">
                <div className="flex gap-2">
                    {TABS.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActiveTab(tab.id)}
                            className={`
                px-6 py-3 font-medium transition-all relative
                ${activeTab === tab.id
                                    ? 'text-orange-400 border-b-2 border-orange-400'
                                    : 'text-slate-400 hover:text-white'
                                }
              `}
                        >
                            {tab.label}
                        </button>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div>
                {ActiveComponent && <ActiveComponent />}
            </div>
        </div>
    );
};

export default OperacionesPage;
